import React from "react";
import {
  HiXMark,
  HiBell,
  HiCheckCircle,
  HiInformationCircle,
} from "react-icons/hi2";
import "../styles/Modals.css";

const NotificationModal = ({ onClose }) => {
  const notifications = [
    {
      id: 1,
      type: "success",
      title: "Card Activated",
      message: "Your new Platinum card has been activated",
      time: "3 days ago",
      read: true,
    },
  ];

  const getIcon = (type) => {
    switch (type) {
      case "success":
        return <HiCheckCircle className="notification-type-icon success" />;
      case "info":
        return <HiInformationCircle className="notification-type-icon info" />;
      default:
        return <HiBell className="notification-type-icon" />;
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content notification-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>
            <HiBell className="header-icon" />
            Notifications
          </h2>
          <button className="close-btn" onClick={onClose}>
            <HiXMark />
          </button>
        </div>

        <div className="notifications-list">
          {notifications.length > 0 ? (
            notifications.map((notification) => (
              <div
                key={notification.id}
                className={`notification-item ${!notification.read ? "unread" : ""}`}
              >
                <div className="notification-icon">
                  {getIcon(notification.type)}
                </div>
                <div className="notification-content">
                  <h4>{notification.title}</h4>
                  <p>{notification.message}</p>
                  <span className="notification-time">{notification.time}</span>
                </div>
              </div>
            ))
          ) : (
            <div className="empty-state">
              <HiBell className="empty-icon" />
              <p>No notifications</p>
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;
